/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LocationPayloadModel model module.
 * @module model/LocationPayloadModel
 * @version v1.0.0
 */
class LocationPayloadModel {
    /**
     * Constructs a new <code>LocationPayloadModel</code>.
     * @alias module:model/LocationPayloadModel
     * @param name {String} Name (required)
     */
    constructor(name) { 
        
        LocationPayloadModel.initialize(this, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name) { 
        obj['name'] = name;
    }

    /**
     * Constructs a <code>LocationPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LocationPayloadModel} obj Optional instance to populate.
     * @return {module:model/LocationPayloadModel} The populated <code>LocationPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LocationPayloadModel();

            if (data.hasOwnProperty('active')) {
                obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('mainId')) {
                obj['mainId'] = ApiClient.convertToType(data['mainId'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * active
 * @member {Boolean} active
 */
LocationPayloadModel.prototype['active'] = undefined;

/**
 * Code
 * @member {String} code
 */
LocationPayloadModel.prototype['code'] = undefined;

/**
 * Foreign Key
 * @member {String} mainId
 */
LocationPayloadModel.prototype['mainId'] = undefined;

/**
 * Name (required)
 * @member {String} name
 */
LocationPayloadModel.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
LocationPayloadModel.prototype['seq'] = undefined;






export default LocationPayloadModel;

